import { Stack, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { Link, useParams } from 'react-router-dom';
import _ from 'lodash';
import { pagesEnum } from 'constants/ui.constants';
import { DashboardCategories } from 'constants/balance.constants';
import { getBalanceByCustomersDataXlsx, getBalancesAndFeesXlsx } from 'services/reports.service';
import { FormButton } from 'theme/elements/Buttons';
import { ButtonComponent } from 'components/ButtonComponent';
import { getCountries } from 'state/reducers/global.reducer';

export const PageInnerLink = (props: { category: DashboardCategories }) => {
	const t = useAppSelector(selectTranslations);
	const theme = useTheme();
	const pagePrefix = 'page.dashboard.dashboardBalances.';
	const filters = useAppSelector((state) => state.dashboard.filters);
	const dispatch = useAppDispatch();
	const { category, plan } = useParams();
	const countries = useAppSelector(getCountries);
	const handleDownloadClickBalanceByCustomers = () => {
		dispatch(getBalanceByCustomersDataXlsx(props.category, filters, true));
	};
	const handleDownloadClick = () => {
		dispatch(getBalancesAndFeesXlsx(props.category, filters, countries, true, plan));
	};

	const getLink = () => {
		switch (props.category) {
			case DashboardCategories.CUSTOMER_BALANCES:
				return {
					label: t(pagePrefix + 'detailsByCustomers'),
					path: `/${pagesEnum.MAIN_DASHBOARD}/${DashboardCategories.CUSTOMER_BALANCES_DETAIL_BY_CUSTOMERS}`,
				};
			case DashboardCategories.CUSTOMER_BALANCES_DETAIL_BY_CUSTOMERS:
				return {
					label: t(pagePrefix + 'backToCustomersBalance'),
					path: `/${pagesEnum.MAIN_DASHBOARD}/${DashboardCategories.CUSTOMER_BALANCES}`,
				};
			case DashboardCategories.MONTHLY_SUBSCRIPTIONS_BY_CUSTOMERS:
				return {
					label: t(pagePrefix + 'backToPlan'),
					path: `/${pagesEnum.MAIN_DASHBOARD}/${DashboardCategories.MONTHLY_SUBSCRIPTIONS}`,
				};
		}
	};
	const link = getLink();
	return (
		<Stack flexDirection={'row'} justifyContent={'space-between'} gap={0} spacing={0}>
			{link && (
				<Link style={{ color: theme.palette.root.formTitle }} to={link.path}>
					{link.label}
				</Link>
			)}
			{props.category === DashboardCategories.CUSTOMER_BALANCES_DETAIL_BY_CUSTOMERS && (
				<FormButton>
					<ButtonComponent
						handleClick={handleDownloadClickBalanceByCustomers}
						text={t('report.excelDownload')}
					/>
				</FormButton>
			)}
			{props.category === DashboardCategories.MONTHLY_SUBSCRIPTIONS_BY_CUSTOMERS && (
				<FormButton>
					<ButtonComponent handleClick={handleDownloadClick} text={t('report.excelDownload')} />
				</FormButton>
			)}
		</Stack>
	);
};
